import context, { IAppUserContext } from '@truckdown/components-systems';
import { Constants, IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';

import searchForm from "./SearchForm/SearchForm.vue";
import listing from "./Listing/Listing.vue";
import listingEdit from "./EditListing/EditListing.vue";
import bulkHoursEdit from "./EditListing/BulkHoursEdit/BulkHoursEdit.vue";
import hoursEdit from "./EditListing/EditHours/EditHours.vue";
import hoursStatus from './HoursStatusComponent/HoursStatusComponent.vue';
import signinOrUpgrade from "./SigninOrUpgrade/SigninOrUpgrade.vue";
import locationSummary from "./LocationSummary/LocationSummary.vue";
import bannerSummary from "./BannerSummary/BannerSummary.vue";
import promotion from "./PromotionComponent/PromotionComponent.vue";
import statusMessage from "./StatusMessage/StatusMessage.vue";
import requestServiceButton from './RequestServiceButton/RequestServiceButton.vue';
import listingTemplateSelectorWrapper from './EditListing/ListingTemplateSelectorWrapper/ListingTemplateSelectorWrapper.vue';
import locationAdminSideNav from './LocationAdminSideNav/LocationAdminSideNav.vue';

class LocationsInitializer implements IInitializer {
    name: string = 'LocationsInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.mixin({
            data: function () {
                return {
                    context: context,
                    constants: Constants
                }
            }
        });

        app.component('listing-avoid',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-avoid" */ './Listing/ListingAvoid/ListingAvoid.vue')));
        app.component('listing-favorite',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-favorite" */ './Listing/ListingFavorite/ListingFavorite.vue')));
        app.component('listing-forward',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-forward" */ './Listing/ListingForward/ListingForward.vue')));
        app.component('listing-notes',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-notes" */ './Listing/ListingNotes/ListingNotes.vue')));
        app.component('listing-rate',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-rate" */ './Listing/ListingRate/ListingRate.vue')));
        app.component('listing-remove',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-remove" */ './Listing/ListingRemove/ListingRemove.vue')));
        app.component('listing-upgrade',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-upgrade" */ './Listing/ListingUpgrade/ListingUpgrade.vue')));
        app.component('listing-report-update',
            defineAsyncComponent(() => import(/* webpackChunkName: "listing-report-update" */ './Listing/ListingReportUpdate/ListingReportUpdate.vue')));
        app.component('general-edit-modal',
            defineAsyncComponent(() => import(/* webpackChunkName: "general-edit-modal" */ './EditListing/GeneralEditModal/GeneralEditModal.vue')));
        app.component('marketing-edit-modal',
            defineAsyncComponent(() => import(/* webpackChunkName: "marketing-edit-modal" */ './EditListing/MarketingEditModal/MarketingEditModal.vue')));
        app.component('tagline-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "tagline-edit" */ './EditListing/ListingTaglineEdit/ListingTaglineEdit.vue')));
        app.component('name-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "name-edit" */ './EditListing/ListingNameEdit/ListingNameEdit.vue')));
        app.component('description-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "description-edit" */ './EditListing/ListingDescriptionEdit/ListingDescriptionEdit.vue')));
        app.component('payment-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "payment-edit" */ './EditListing/ListingPaymentEdit/ListingPaymentEdit.vue')));
        app.component('numbers-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "numbers-edit" */ './EditListing/ListingNumbersEdit/ListingNumbersEdit.vue')));
        app.component('website-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "website-edit" */ './EditListing/ListingWebsiteEdit/ListingWebsiteEdit.vue')));
        app.component('address-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "address-edit" */ './EditListing/ListingAddressEdit/ListingAddressEdit.vue')));

        app.component('services-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "services-edit" */ './EditListing/ListingServicesEdit/ListingServicesEdit.vue')));
        app.component('networks-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "networks-edit" */ './EditListing/ListingNetworksEdit/ListingNetworksEdit.vue')));
        app.component('logo-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "logo-edit" */ './EditListing/ListingLogoEdit/ListingLogoEdit.vue')));
        app.component('photos-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "photos-edit" */ './EditListing/ListingPhotosEdit/ListingPhotosEdit.vue')));
        app.component('features-edit',
            defineAsyncComponent(() => import(/* webpackChunkName: "features-edit" */ './EditListing/ListingFeaturesEdit/ListingFeaturesEdit.vue')));
        app.component('admin-info',
            defineAsyncComponent(() => import(/* webpackChunkName: "admin-info" */ './Listing/AdminInfo/AdminInfo.vue')));
        app.component('search-form', searchForm);
        app.component('listing', listing);
        app.component('edit-listing', listingEdit);
        app.component('bulk-hours-edit', bulkHoursEdit);
        app.component('edit-hours', hoursEdit);
        app.component('promotion', promotion);
        app.component('hours-status', hoursStatus);
        app.component('signin-or-upgrade', signinOrUpgrade);
        app.component('location-summary', locationSummary);
        app.component('banner-summary', bannerSummary);
        app.component('status-message', statusMessage);
        app.component('request-service-button', requestServiceButton);
        app.component('listing-template-selector-wrapper', listingTemplateSelectorWrapper);
        app.component('request-service-form',
            defineAsyncComponent(() => import(/* webpackChunkName: "request-service-form" */ './RequestServiceForm/RequestServiceForm.vue')));
        app.component('request-register-form',
            defineAsyncComponent(() => import(/* webpackChunkName: "request-register-form" */ './RequestRegisterForm/RequestRegisterForm.vue')));
        app.component('location-admin-side-nav', locationAdminSideNav);
        return Promise.resolve();
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new LocationsInitializer();
    }
});
